<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner">
      <h2 class="rew19_second_title">정기구매 History 상세 현황</h2>

      <h3 class="rew19_third_title">주문 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>정기구매 주문번호</em>
          <span class="substance">{{detail.aro_no}}</span>
        </li>
        <li class="type1">
          <em>결제일</em>
          <span class="substance">{{detail.payment_dt}}</span>
        </li>
        <li class="type1">
          <em>결제방법</em>
          <span class="substance">{{detail.payment_info}}</span>
        </li>
        <li class="type1">
          <em>할인율</em>
          <span class="substance">{{detail.saving_percentage}}%</span>
        </li>
        <li class="type1">
          <em>진행회차</em>
          <span class="substance">총 {{detail.payment_count}}회</span>
        </li>
        <li class="type1">
          <em>상태</em>
          <span class="substance">
            <span class="gep_btnRight">{{detail.payment_status}}</span>
            <a
            v-if="detail.payment_check == 'N'"
            href="#"
            class="rew19_btn_border"
            @click.stop.prevent="onClickRepayment(history)">재결제</a>
          </span>
        </li>
      </ul>

      <h3 class="rew19_third_title">배송 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>수령인</em>
          <span class="substance">{{detail.ship_name}}</span>
        </li>
        <li class="type1">
          <em>전화 번호</em>
          <span class="substance">{{detail.ship_tel}}</span>
        </li>
        <li class="type1">
          <em>핸드폰 번호</em>
          <span class="substance">{{detail.ship_phone}}</span>
        </li>
        <li class="type1">
          <em>주소</em>
          <span class="substance">{{detail.ship_addr}}</span>
        </li>
      </ul>

      <h3 class="rew19_third_title">주문 상품</h3>
      <div v-for="(pd) in pdList" v-bind:key="pd.pd_id" class="rew19_payment_content">
        <div class="rew19_flex_box">
          <div class="rew19_payment_list__img">
            <img :src="pd.pd_img_url1" :alt="pd.pd_id" title
                 onError="imageError(this)" data-error-cnt="0"
            />
          </div>

          <div class="rew19_payment_list__infor">
            <h4>{{pd.pd_name_kr}}</h4>
            <ul class="rew19_payment_items flex">
              <li>
                <span class="rew19_point rew19_gDetail">{{$fmt.WON(pd.pd_amt)}} 원 / {{pd.pd_count}}개</span>
              </li>
              <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
                <span class="rew19_gDetail">
                  <em>SV</em> {{$fmt.PV(pd.pv)}}
                </span>
              </li>
              <li v-if="getMemberType() == 'DIST'">
                <span class="rew19_gDetail">
                  <em>CSV</em>{{$fmt.PV(pd.cv)}}
                </span>
              </li>
<!--              <li v-if="getMemberType() == 'DIST'">-->
<!--                <span class="rew19_gDetail">-->
<!--                  <em>SB</em> {{$fmt.PV(pd.sb)}}-->
<!--                </span>-->
<!--              </li>-->
              <li>
                <span class="rew19_gDetail">
                  <em>합계</em> {{$fmt.WON(pd.total_amt)}} 원
                </span>
              </li>
            </ul>

            <ul class="rew19_payment_items flex add" v-for="(agm, idx) in pd.agm_info" :key="idx">
              <li>
                  <span class="rew19_gDetail"><em>이름</em>{{agm.agm_name}}</span>
              </li>
              <li>
                  <span class="rew19_gDetail"><em>코드</em>{{agm.agm_code}}</span>
              </li>
              <li>
                  <span class="rew19_gDetail"><em>코드별명</em>{{agm.agm_detail}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>


      <div class="rew19_payment_bottom">
        <ul class="rew19_payList">
          <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
            <em class="rew19_payTitle">합계 SV</em>
            <span class="rew19_payDetail">{{$fmt.PV(detail.total_pv)}}</span>
          </li>
          <li v-if="getMemberType() == 'DIST'">
            <em class="rew19_payTitle">합계 CSV</em>
            <span class="rew19_payDetail">{{$fmt.PV(detail.total_cv)}}</span>
          </li>
<!--          <li v-if="isShowTotalSb">-->
<!--            <em class="rew19_payTitle">합계 SB</em>-->
<!--            <span class="rew19_payDetail">{{$fmt.PV(detail.total_sb)}}</span>-->
<!--          </li>-->
          <li class="lastLine">
            <em class="rew19_payTitle">주문금액</em>
            <span class="rew19_payDetail rew19_point">
              <strong>{{$fmt.WON(detail.total_amt)}} 원</strong>
            </span>
          </li>
        </ul>
      </div>

      <div v-if="detail.delivery_status == '1'"
        class="rew19_responsive_btns gepTaye1">
        <a @click="onClickDelivery" class="rew19-btn-normal" target="_blank">배송조회</a>
        <router-link :to="{name:'aroHistoryList'}" class="rew19-btn-border">목록</router-link>
      </div>
      <div v-if="detail.delivery_status != '1'"
        class="rew19_responsive_btns gepTaye1">
        <router-link :to="{name:'aroHistoryList'}" class="rew19-btn-normal">목록</router-link>
      </div>
    </div>
    <!--rew19_contents_inner-->
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "aroHistoryDetail",
  extends: AroBase,
  computed: {
  },
  props:{
    aro_no: {
      type: String,
      required: true
    },
    aro_order_no: {
      type: String,
      required: true
    }
  },
  data: () => ({
    //View Data
    params : {},
    detail: {},
    pdList: [],
    testText : "",
    // isShowTotalSb : false,
  }),

  created() {
  },

  mounted() {
    let _this = this;

    _this.loadData();

    // if(_this.getMemberType() == "DIST" && _this.getMemberTitle() >= 40){
    //   _this.isShowTotalSb = true;
    // }
  },

  methods: {

    apiGetAroHistoryDetail:function(){
      let _this = this;
        return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro_history_detail`, {
          params: {
            aro_no : _this.aro_no,
            aro_order_no : _this.aro_order_no
          }
        });
    },

    loadAroHistoryDetail:function(){
      let _this = this;
      _this.$showLoading();
      _this.apiGetAroHistoryDetail().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.detail = res.data;
          _this.pdList = res.data.pd_list;
        }
      }).catch((err)=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    loadData: function(){
      let _this = this;

      if(_this.isLogined()){
          _this.loadAroHistoryDetail();
      }
    },

    onClickRepayment : function(item){
      let _this = this;

      const options = {cancelLabel: '취소', okLabel:'확인'};
      _this.$dialogs.confirm("해당 ARO에 대한 재결제를 진행하시겠습니까?<br>(결제 정보를 다시 한번 확인하신 후 재결제를 진행해주세요.)", options).then(res=>{
        if(res.ok){
          _this.doRepayment(item);
        }
      });
    },

    //재결제
    doRepayment(item){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiMyAroRepay(item.ship_name, item.aro_no, item.payment_target).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("처리가 완료 되었습니다.", {okLabel:"확인"})
          .then(res => {});

        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    apiMyAroRepay : function(member_name, aro_no, payment_target){
      let _this = this;
        return _this.$http.get(`${_this.$aroApiBasePath}/aro/repayment`, {
          params: {
            member_name : member_name,
            aro_no : aro_no,
            payment_target : payment_target
          }
        });
    },

    apiGetDeliveryUrl : function(sapNumber, payDate){
      let _this = this;
        return _this.$http.get(`${_this.$aroApiBasePath}/aro/getDeliveryLink`, {
          params: {
            sapNumber : sapNumber,
            payDate : payDate
          }
        });
    },

    //배송 조회 변경
    onClickDelivery(){
      let _this = this;

      var sapNumber = _this.detail.sap_order_no;
      var payDate = _this.detail.payment_dt;

      if(sapNumber == null || sapNumber == undefined || sapNumber == ""){
        _this.$dialogs.alert("주문번호가 존재하지 않습니다.")
        .then(res => {});
        return;
      }

      _this.apiGetDeliveryUrl(sapNumber, payDate).then(res=>{
        if (res.status === 200 && res.data.status === "0000") {
          var delivery_link = res.data.deliveryLink;
           window.open(delivery_link, "", "width=553,height=270,scrollbars=no,left=50,top=50");
        }else{
          _this.$dialogs.alert(res.data.message).then(res => {});
        }
      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});
      }).finally(()=>{
        _this.$hideLoading();
      });

    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/my/aro/historyDetail.vue